module.exports = __webpack_public_path__ + "static/media/01-kor.55eda938.png";